/** @jsxImportSource @emotion/react */
import PropTypes from "prop-types";
import getIcon from "./getIcon";
import { alertCss, headerCss, iconCss, textCss } from "./index.css";

export default function Alert({ title, message, type }) {
  return (
    <div css={alertCss({ type })}>
      <div css={iconCss}>{getIcon(type)}</div>

      <h4 css={headerCss}>{title}</h4>

      <p css={textCss}>{message}</p>
    </div>
  );
}

Alert.propTypes = {
  title: PropTypes.node.isRequired,
  type: PropTypes.oneOf(["error", "info"]),
  message: PropTypes.node,
};
